<template>
  <!-- 精彩时刻 -->
  <div class="wonderful" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="userName" placeholder="请输入项目应用名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      <el-input class="s_input" v-model="userName" placeholder="请输入用户名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column prop="number" label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="项目应用" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="" label="活动编号" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="" label="活动名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userName" label="用户名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdTime" label="发布时间" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="" label="发布内容" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="图片" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="show_img" @click="previewImage(scope.row.busiLicense)">预览图片</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button class="btn" type="danger" size="small" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      userName: "",
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）

      // 图片预览
      showViewer: false,
      imgList: [],
    }
  },
  created() {
    // this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      this.$axios
        .get(this.$api.supplierInfoSupplierPageList, {
          params: {
            userName: this.userName,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          let list = res.result.list
          this.tableData = list
          this.totalItemsCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("即将删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .put(`${this.$api.deleteSysUser}/${row.userId}`)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
              }
              this.getSysUserList()
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getSupplierList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getSupplierList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getSupplierList()
    },
  },
}
</script>

<style scoped lang="scss">
.wonderful {
}
</style>
